module.exports = __webpack_public_path__ + "static/media/24UHCHR8.2729eedc.jpg";